import TabMenu from './util/tabmenu';
import Selected from './util/selected';

window.signature2nd = {
    tabmenu:new TabMenu({
        el:"[data-id='tab-menu']",
        idx:"tab1-1"
    }),
    selected1:new Selected({
        el:"[data-id='item-table1']"
    }),
    selected2:new Selected({
        el:"[data-id='item-table2']"
    }),
    layerRestored:promokit.layer({
        contents:'#layer-restored',
        render:true
    }),
    layerApply:promokit.layer({
        contents:'#layer-apply',
        render:true
    }),
    layerReceive:promokit.layer({
        contents:'#layer-receive',
        render:true
    }),
};

// 아이템복구리스트 닫기
// signature2nd.layerRestored.on("closestart", ()=>{
//     console.log("layerRestored close")
// });

// 아이템복구신청 닫기
// signature2nd.layerApply.on("closestart", ()=>{
//     console.log("layerApply close")
// });

// 악마왕의선물상자 닫기
// signature2nd.layerReceive.on("closestart", ()=>{
//     console.log("layerReceive close")
// });


// WEBPACK FOOTER //
// ./src/js/signature2nd.js